export default "__VITE_ASSET__DsnYwNDK__"